import React,{useState} from 'react'
import {BezierCurveEditor} from 'react-bezier-curve-editor';
export default function Cubicbz(props) {
    const [val,setval]=useState([]);
    const [clkval,setclkval]=useState("editable")
    const idg=['bznms1',
    'bznms2',
    'bznms3',
    'bznms4',
    'bznms5']
    const efzs=[
      "ease",
      "linear",
      "ease-in",
      "ease-out",
      "ease-in-out"]
    const brigthen=(idz)=>{
      for(let i=0;i<5;i++){
        document.getElementsByClassName('bznms')[i].classList='bznms bzimgs flex'
      }
      document.getElementById(idz).classList.add("bznmsactive")
    }
    const ease_act=()=>{
      setclkval(efzs[0])
      props.beizr(efzs[0])
    }
    const linear_act=()=>{
      setclkval(efzs[1])
      props.beizr(efzs[1])
    }
    const easein_act=()=>{
      setclkval(efzs[2])
      props.beizr(efzs[2])
    }
    const easeout_act=()=>{
      setclkval(efzs[3])
      props.beizr(efzs[3])
    }
    const easeinout_act=()=>{
      setclkval(efzs[4])
      props.beizr(efzs[4])
    }
    const reset_act=()=>{
      setclkval("reset")
      props.beizr("cubic-bezier(0.455, 0.030, 0.515, 0.955)")
    }
    const configure_act=()=>{
      setclkval("editable")
      for(let i=0;i<5;i++){
        document.getElementsByClassName('bznms')[i].classList='bznms bzimgs flex'
      }
    }
    const apply_act=()=>{
      let bzlst=Object.values(val)[0]
      props.beizr(`cubic-bezier(${bzlst[0].toFixed(2)},${bzlst[1].toFixed(2)},${bzlst[2].toFixed(2)},${bzlst[3].toFixed(2)})`)
    }
    const ease_arr=[0.17,0.67,0.83,0.67]
    const linear_arr=[0,0,1,1]
    const easein_arr=[0.42,0,1,1]
    const easeout_arr=[0,0,0.58,1]
    const easeinout_arr=[0.42,0,0.58,1]
    const def_arr=[0.455, 0.030, 0.515, 0.955]
    let element;
    let applybtn;
    switch (clkval) {
      case "ease":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={ease_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{ease_arr[0]}</h5>
          <h5 className='bzvals'>{ease_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{ease_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{ease_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;
      case "linear":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={linear_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{linear_arr[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{linear_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{linear_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{linear_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;
      case "ease-in":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={easein_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{easein_arr[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{easein_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{easein_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{easein_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;
      case "ease-out":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={easeout_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{easeout_arr[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeout_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeout_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeout_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;
      case "ease-in-out":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={easeinout_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{easeinout_arr[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeinout_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeinout_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{easeinout_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;
      case "editable":
        element=<>
        <BezierCurveEditor onChange={val=>setval({val})} size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' />
        {Object.values(val).map((ele)=><div className='flex'>
          <h5 className='bzvals'>{ele[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{ele[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{ele[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{ele[3].toFixed(2)}</h5>
        </div>)}
        </>
        applybtn=<button onClick={apply_act} style={{ width:'100px',height:'25px',background:'#00AABB',border:'none',position:'absolute',right:'15px',bottom:'5px',borderRadius:'5px',cursor:'pointer'}}>Apply</button>
        break;
      case "reset":
        element=<>
        <BezierCurveEditor size={150} outerAreaColor='#212438' innerAreaColor='#161620' rowColor='#243452' value={def_arr}/>
        <div className='flex'>
          <h5 className='bzvals'>{def_arr[0].toFixed(2)}</h5>
          <h5 className='bzvals'>{def_arr[1].toFixed(2)}</h5>
          <h5 className='bzvals'>{def_arr[2].toFixed(2)}</h5>
          <h5 className='bzvals'>{def_arr[3].toFixed(2)}</h5>
        </div>
        </>
        break;

    }
  return (
    <>
    <div className='imgbox flex' >
      <div className='bzimgs' id='bzimg1'></div>
      <div className='bzimgs' id='bzimg2'></div>
      <div className='bzimgs' id='bzimg3'></div>
      <div className='bzimgs' id='bzimg4'></div>
      <div className='bzimgs' id='bzimg5'></div>
    </div>
    <div className='imgbox flex' >
      <div className='bznms bzimgs flex' id='bznms1' onClick={()=>{ease_act();brigthen(idg[0])}}>ease</div>
      <div className='bznms bzimgs flex' id='bznms2' onClick={()=>{linear_act();brigthen(idg[1])}}>linear</div>
      <div className='bznms bzimgs flex' id='bznms3' onClick={()=>{easein_act();brigthen(idg[2])}}>easeIn</div>
      <div className='bznms bzimgs flex' id='bznms4' onClick={()=>{easeout_act();brigthen(idg[3])}}>esOut</div>
      <div className='bznms bzimgs flex' id='bznms5' onClick={()=>{easeinout_act();brigthen(idg[4])}}>esIO</div>
    </div>
    <div className='bezierEditor'>
      {element}
    <div className='bzpointhead flex'>Beizerpoints</div>
    
    <button onClick={configure_act} style={{ width:'78px',height:'25px',background:'#00AABB',border:'none',position:'absolute',left:'14px',bottom:'100px',borderRadius:'5px',cursor:'pointer'}}>configure</button>
    <button onClick={reset_act} style={{ width:'55px',height:'25px',background:'#00AABB',border:'none',position:'absolute',left:'98px',bottom:'100px',borderRadius:'5px',cursor:'pointer'}}>reset</button>
    <div className='progression flex'>progression</div>
    {applybtn}
    
  </div>
    </>
    
  )
}
